import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IProps {
  className?: string;
  id: string;
}

function ImportLabel({ className, id }: Readonly<IProps>): JSX.Element {
  const { Importers } = useStore();
  const original = Importers.get(id);
  return (
    <div className={classNames({ [skeleton]: original.isPending }, className)}>{original.name}</div>
  );
}

export default observer(ImportLabel);
